<template>
  <v-container fluid>
    <v-dialog v-model="createAppDialog" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{
            selected && selected.length && selected.length === 1
              ? "Edit App"
              : "Create New App"
          }}
        </v-card-title>
        <v-card-text>
          <add-app
            ref="addApp"
            :put="
              selected && selected.length && selected.length === 1
                ? selected[0]
                : null
            "
            @loading="addButtonLoader = $event"
            @success="editDone"
          >
            <label slot="before-name">App Name</label>
            <label slot="before-culture">App Culture</label>
            <label slot="before-disc">App Description</label>
            <label slot="before-nlu">NLU Engine</label>
            <label slot="before-token">Token</label>
            <label slot="before-priority"
              >App Priority (where 0 is the lowest priority)</label
            >
            <label slot="before-confidence">App Minimum Confidence</label>
          </add-app>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="createAppDialog = false"> Cancel </v-btn>
          <v-btn :loading="addButtonLoader" color="primary" @click="addNewApp">
            {{
              selected && selected.length && selected.length === 1
                ? "Save"
                : "Create"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteAppDialog" width="400">
      <v-card v-if="selected && selected.length">
        <v-card-title class="headline" primary-title>
          Delete {{ selected.map((app) => app.name).join(", ") }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this
          {{ selected.length > 1 ? selected.length : "" }} App{{
            selected.length > 1 ? "s" : ""
          }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :loading="addButtonLoader"
            color="error"
            outline
            @click="deleteApps"
          >
            Delete
          </v-btn>
          <v-btn
            color="black"
            class="white--text"
            @click="deleteAppDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <h1>My Apps</h1>
      <v-spacer />
      <div class="text-right">
        <v-btn to="/nlp/intents-report-tool" color="primary" outline>
          Testing Tool
          <v-icon class="ml-1">mdi-file-table</v-icon>
        </v-btn>
        <v-btn to="/nlp/unknown-terms" color="primary">
          Unknown Utterances
          <v-icon class="ml-1">help</v-icon>
        </v-btn>
      </div>

      <!-- <v-btn large round color="primary" @click="unknownTermsDialog = true"><v-icon>list</v-icon> Check Unknown Terms</v-btn> -->
    </v-layout>
    <v-flex xs12> </v-flex>
    <v-flex xs12>
      <v-card class="card-curvey">
        <v-layout row wrap class="px-0 mx-0">
          <v-flex xs4>
            <v-text-field
              v-model="queries.q"
              placeholder="Search By Name, Type or Culture"
              append-icon="search"
              class="mt-2"
              outline
            />
          </v-flex>
          <v-spacer />

          <v-flex class="mx-0" style="justify-content: flex-end; display: flex">
            <div>
              <v-btn
                :disabled="
                  !selected || !selected.length || selected.length !== 1
                "
                :loading="!!(addButtonLoader && selected.length)"
                color="blue-grey"
                class="nlp-nav-btn mx-0"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                "
                small
                outline
                @click="openAddDialog(false)"
              >
                <v-icon>edit</v-icon>
                Edit
              </v-btn>
              <v-btn
                :disabled="!selected || !selected.length"
                color="blue-grey"
                class="nlp-nav-btn mx-0"
                style="border-radius: 0"
                small
                outline
                @click="deleteAppDialog = true"
              >
                <span class="botter-trash-icon" style="padding-right: 6px" />
                Delete
              </v-btn>
              <v-btn
                :disabled="
                  !!(
                    !selected ||
                    !selected.length ||
                    selected.length !== 1 ||
                    syncedAppStatus.status ||
                    selected.filter((a) => a.app_type === 'rasa').length
                  )
                "
                color="blue-grey"
                class="nlp-nav-btn mx-0"
                style="border-radius: 0"
                small
                outline
                @click="syncApp"
              >
                <v-icon>sync</v-icon>
                Sync
              </v-btn>
              <export-app :apps="selected" @success="getApps()" />
              <!-- <import-json-app /> -->
              <import-json-app :apps="selected" @success="getApps()" />
            </div>
          </v-flex>

          <v-flex class="mx-0" style="justify-content: flex-end; display: flex">
            <v-btn
              color="blue-grey"
              class="nlp-nav-btn ml-0"
              small
              outline
              @click="smalltalksConfirmDialog = true"
            >
              <v-icon>import_contacts</v-icon>
              Import Small Talks
              <v-dialog v-model="smalltalksConfirmDialog" max-width="590">
                <v-card class="border-radius-standard">
                  <v-card-title class="headline">
                    Import Small Talks
                    <v-spacer />
                    <v-icon @click="smalltalksConfirmDialog = false"
                      >close</v-icon
                    >
                  </v-card-title>
                  <v-card-text>
                    <p style="font-size: 120%">
                      Are you sure you want to import small talks?
                    </p>
                    <v-alert
                      :value="true"
                      color="amber darken-3"
                      icon="info"
                      class="border-radius-standard"
                      outline
                    >
                      Notice: "Import" will totally override the existing
                      intents.
                    </v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      style="font-size: 120%"
                      @click="importSmallTalks({ override_intents: true })"
                    >
                      Import
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-btn>

            <v-btn
              :loading="!!(addButtonLoader && !selected.length)"
              color="blue-grey"
              class="nlp-nav-btn mr-0"
              small
              outline
              @click="openAddDialog(true)"
            >
              <v-icon>add</v-icon>
              New
            </v-btn>
          </v-flex>

          <!-- <json-excel
            v-if = "queriedApps.length"
            class="nlp-nav-btn v-btn blue-grey--text"
            style = "border: 1px solid"
            type = "csv"
            :name = "`Botter NLP Apps ${ $moment().format('YYYY-M-D hh mm') }.csv`"
            :data = "exportedApps">
              <v-icon>north</v-icon>
              Export
          </json-excel>
          <v-btn
            v-else
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            disabled>
            <v-icon>north</v-icon>
            Export
          </v-btn> -->
        </v-layout>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="queriedApps"
            item-key="name"
            no-data-text="No Apps Available"
            select-all
            class="elevation-1 nlp-data-table"
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.index === 0 && !props.item.name"
                class="text-center"
                style="width: 100%"
              >
                <td />
                <td />
                <td />
                <td class="text-center">No Apps Available</td>
                <td />
                <td />
              </tr>
              <tr v-if="props.item.name">
                <td>
                  <v-checkbox v-model="props.selected" primary hide-details />
                </td>
                <td>
                  <span
                    class="primary--text pointer-cursor"
                    @click="selectApp(props.item)"
                  >
                    {{ props.item.name }}
                  </span>
                </td>
                <!-- <td class="text-center">{{ props.item.type }}</td> -->
                <td class="text-center" style="text-transform: uppercase">
                  {{
                    props.item.app_type === "rasa"
                      ? "BOTTER"
                      : props.item.app_type
                  }}
                </td>
                <td class="text-center">
                  {{
                    $moment(props.item.last_modified).format(
                      "h:mm A D/MMM/YYYY"
                    )
                  }}
                </td>
                <td class="text-center">
                  {{
                    $moment(props.item.last_trained).format("h:mm A D/MMM/YYYY")
                  }}
                </td>
                <td class="text-center">{{ props.item.culture.name }}</td>
                <td class="text-center">{{ props.item.priority || 0 }}</td>
                <td class="text-center">
                  <v-icon
                    :color="
                      syncedAppStatus.app === props.item.id &&
                      syncedAppStatus.status
                        ? 'yellow'
                        : 'green'
                    "
                    >stop_circle</v-icon
                  >
                </td>
                <!-- <td class="text-center"><v-icon>more_horiz</v-icon></td> -->
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import JsonExcel from "vue-json-excel";
import unknownWords from "../components/insights/unknown-words";
import AddApp from "../components/nlp/apps/AddApp.vue";
import ExportApp from "../components/nlp/apps/ExportApp.vue";
import ImportApp from "../components/nlp/apps/ImportApp.vue";
import ImportJsonApp from "../components/nlp/apps/ImportJsonApp.vue";
export default {
  name: "Nlp",
  components: {
    AddApp,
    JsonExcel,
    unknownWords,
    ImportApp,
    ImportJsonApp,
    ExportApp,
  },
  data() {
    return {
      queries: {
        q: "",
      },
      syncedAppStatus: [],
      smalltalksConfirmDialog: false,
      createAppDialog: false,
      unknownTermsDialog: false,
      deleteAppDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: "App Name",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "App Type", value: "app_type", align: "center" },
        { text: "Last Modified", value: "last_modified", align: "center" },
        { text: "Last Trained", value: "last_trained", align: "center" },
        { text: "Culture", value: "culture", align: "center" },
        { text: "Priority", value: "priority", align: "center" },
        { text: "Syncing Status", value: "priority", align: "center" },
        // { text: '', value: 'actions' }
      ],
    };
  },
  computed: {
    queriedApps() {
      return this.$store.getters["nlp/apps/query"](this.queries.q);
    },
    exportedApps() {
      return this.queriedApps.map((app) => ({
        ...app,
        culture: app.culture.name,
      }));
    },
    excelHeaders() {
      return this.headers.map((h) => {
        let t = {};
        t[h.text] = h.value;
        return t;
      });
    },
  },
  watch: {
    // selected: {
    //   deep: true,
    //   handler(val) {
    //     if(val && val.length && val.length > 1) {
    //       this.selected = [val[val.length - 1]]
    //     }
    //   }
    // }
  },
  async mounted() {
    // get apps
    await this.getApps();
  },
  methods: {
    editDone() {
      this.createAppDialog = false;
      this.selected = [];
    },
    async getApps() {
      await this.$store.dispatch("nlp/apps/get", null);
    },
    openAddDialog(reset = true) {
      if (reset) this.selected = [];
      this.createAppDialog = true;
    },
    addNewApp() {
      if (this.$refs.addApp) this.$refs.addApp.submit();
    },
    selectApp(app) {
      this.$store.dispatch("nlp/apps/select", app);
      if (this.$route.query.from) {
        this.$router.push({
          name: this.$route.query.from,
          params: { id: app.id },
        });
      } else {
        this.$router.push(`/nlp/app/${app.id}/intents`);
      }
    },
    async deleteApps() {
      this.$store.dispatch("setLoader", true);
      await this.$store.dispatch("nlp/apps/delete/multiple", this.selected);

      this.deleteAppDialog = false;
      this.$store.dispatch("setSnackbar", {
        text: `Deleted Successfully`,
        color: "success",
      });
      this.selected = [];
    },
    async getSyncingStatus(app) {
      try {
        const { data } = await this.$http_nlp.get(`/apps/${app}/status`);
        return {
          app,
          status: data.data.filter((p) => p.status === "SYNCING").length,
        };
      } catch (err) {
        return { app, status: null };
      }
    },
    async trackSyncStatus(app, time = 5000) {
      this.syncedAppStatus = await this.getSyncingStatus(app);
      if (this.syncedAppStatus.status) {
        setTimeout(() => {
          this.trackSyncStatus(app);
        }, time);
      }
    },
    async importSmallTalks(params) {
      try {
        if (!this.$store.state.bot || !this.$store.state.bot.botId) return;
        this.$store.dispatch("setLoader", true);
        await this.$http_nlp({
          url: "/apps/import/smalltalks",
          method: "post",
          data: { bot_id: this.$store.state.bot.botId },
          params,
        });

        this.$store.dispatch("setLoader", true);
        await this.getApps();
        this.$store.dispatch("setSnackbar", {
          text: `Imported Successfully`,
          color: "success",
        });
        this.smalltalksConfirmDialog = false;
      } catch (err) {
        this.smalltalksConfirmDialog = false;
        throw err;
      }
    },
    async syncApp() {
      this.$store.dispatch("setLoader", true);
      await this.$store.dispatch("nlp/apps/sync/single", this.selected[0].id);

      this.trackSyncStatus(this.selected[0].id);
      this.$store.dispatch("setSnackbar", {
        text: `Synced Successfully`,
        color: "success",
      });
    },
  },
};
</script>

<style lang="scss" src="../assets/sass/commponents/nlp.scss"></style>
